"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[14600],{

/***/ 14600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Controls_AddToWishList; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/components/Search/Card/Controls/AddToWishList/styles.js
var styles = __webpack_require__(86095);
// EXTERNAL MODULE: ../shared/src/svg/new-heart.js
var new_heart = __webpack_require__(78078);
// EXTERNAL MODULE: ../shared/src/contexts/wishlist/index.js + 56 modules
var wishlist = __webpack_require__(59808);
;// CONCATENATED MODULE: ../shared/src/constants/wishlistActions.js
var WISHLIST_ACTIONS = {
  ADD: 'add',
  REMOVE: 'remove'
};
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Controls/AddToWishList/index.js
var __jsx = react.createElement;





var AddToWishList = function AddToWishList(_ref) {
  var offerId = _ref.offerId,
    sendWishlistClickEvent = _ref.sendWishlistClickEvent,
    handleWishlistClick = _ref.handleWishlistClick,
    isOfferOnWishlist = _ref.isOfferOnWishlist;
  var _ref2 = (0,react.useContext)(wishlist/* WishlistContext */.j) || {},
    addToWishlist = _ref2.addToWishlist,
    removeFromWishlist = _ref2.removeFromWishlist,
    isOnWishlist = _ref2.isOnWishlist;
  var _useState = (0,react.useState)(isOfferOnWishlist || isOnWishlist(offerId)),
    isWishlistButtonActive = _useState[0],
    setIsWishlistButtonActive = _useState[1];
  var handleWishlistButtonClick = function handleWishlistButtonClick(e) {
    if (handleWishlistClick) {
      handleWishlistClick(e, offerId);
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    var hasSucceeded = isWishlistButtonActive ? removeFromWishlist(offerId) : addToWishlist(offerId);
    if (!hasSucceeded) {
      return;
    }
    setIsWishlistButtonActive(!isWishlistButtonActive);
    if (sendWishlistClickEvent) {
      sendWishlistClickEvent(isWishlistButtonActive ? WISHLIST_ACTIONS.REMOVE : WISHLIST_ACTIONS.ADD);
    }
  };
  (0,react.useEffect)(function () {
    if (isWishlistButtonActive === isOnWishlist) {
      return;
    }
    setIsWishlistButtonActive(isOfferOnWishlist || isOnWishlist(offerId));
  }, [isOfferOnWishlist, isOnWishlist]);
  return __jsx(styles/* Wrapper */.i, null, __jsx(new_heart/* default */.Z, {
    className: "wishlist-button",
    active: isWishlistButtonActive,
    onClick: handleWishlistButtonClick
  }));
};
/* harmony default export */ var Controls_AddToWishList = (AddToWishList);

/***/ })

}]);